import { BACKEND_ENDPOINT, log } from "../utils/Common";

/**
 * Accessor for the Reporting Service
 */
export async function getReport(accessToken) {
  const response = await fetch(BACKEND_ENDPOINT + "reporting", {
    headers: {
      'Content-Type': 'application/json', 
      'Accept': 'application/json', 
      'Authorization': `Bearer ${accessToken}`
    }
  });
  if (!response.ok) {
    throw new Error(response.status);
  }
  if (response.status === 204) {
    return null;
  }
  return response.json();
}
/**
 * Accessor for the Reporting Service
 */
export async function testUrl(paymentService, user, amount) {
  const query = [
    `paymentService=${paymentService}`,
    `&user=${user}`,
    `&amount=${amount}`,
  ].join("")
  const response = await fetch(BACKEND_ENDPOINT + `reporting/test-url?${query}`, {
    headers: {
      'Content-Type': 'application/json', 
      'Accept': 'application/json'
    }
  });
  if (!response.ok) {
    throw new Error(response.status);
  }
  if (response.status === 204) {
    return null;
  }
  response.text().then((data)=>{
    log("reporting/test-url?urlString")
    log(data)
  });
}
